module.exports = __webpack_public_path__ + "img/sport-2.ce76884c.jpg";